<template>
  <div class="create_wrapper custom_card">
    <!-- START:: CARD TITLE -->
    <div class="card-header">
      <h4 class="card-title">{{ $t("CRUD.Update.main_title") }}</h4>
    </div>
    <!-- END:: CARD TITLE -->

    <!-- START:: UPDATE FORM WRAPPER -->
    <form @submit.prevent="validateCreateForm">
      <div class="container">
        <div class="row justify-content-between">
          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input"
                v-model.trim="updateData.project_name"
              />
              <label class="form-label">اسم المشروع</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="textarea"
                class="form-control"
                id="name_input"
                v-model.trim="updateData.description_location"
              />
              <label class="form-label">وصف المكان</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="textarea"
                class="form-control"
                id="name_input"
                v-model.trim="updateData.website_link"
              />
              <label class="form-label">لينك الموقع</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="number"
                class="form-control"
                id="name_input"
                v-model.trim="updateData.phone"
              />
              <label class="form-label">
                {{ $t("settings.contactData.phone") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="email"
                class="form-control"
                id="name_input2"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.email"
              />
              <label class="form-label">
                {{ $t("settings.contactData.email") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input3"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.whatsapp"
              />
              <label class="form-label">
                {{ $t("settings.contactData.whatsapp") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input4"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.facebook"
              />
              <label class="form-label">
                {{ $t("settings.contactData.facebook") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input5"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.twitter"
              />
              <label class="form-label">
                {{ $t("settings.contactData.twitter") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input6"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.youtube"
              />
              <label class="form-label">
                {{ $t("settings.contactData.youtube") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <!-- <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input7"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.snapchat"
              />
              <label class="form-label">{{
                $t("settings.contactData.snapchat")
              }}</label>
            </div>
          </div> -->
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input8"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.instagram"
              />
              <label class="form-label">
                {{ $t("settings.contactData.instagram") }}
              </label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="textarea"
                class="form-control"
                id="name_input"
                v-model.trim="updateData.pinterest"
              />
              <label class="form-label">pinterest</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input8"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.ios_link"
              />
              <label class="form-label">آب ستور</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: INPUT WRAPPER -->
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                id="name_input8"
                @input="checkIfInputIsEmpty"
                v-model.trim="updateData.android_link"
              />
              <label class="form-label">جوجل بلاي</label>
            </div>
          </div>
          <!-- END:: INPUT WRAPPER -->

          <!-- START:: MAP -->
          <div class="col-12 fadeIn">
            <div class="large-map">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  id="autocomplete_ar"
                  placeholder=""
                  @input="getAddressAr"
                  v-model="updateData.address"
                />
                <label class="form-label">العنوان</label>
              </div>

              <GmapMap
                :center="center"
                :zoom="12"
                map-type-id="terrain"
                style="width: 100%; height: 600px;"
              >
                <GmapMarker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @drag="updateCoordinates"
                  @click="clickMethod(m)"
                />
              </GmapMap>
            </div>
          </div>
          <!-- END:: MAP -->
        </div>
      </div>

      <div class="buttons_wrapper">
        <!-- START:: BUTTON -->
        <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
        <!-- END:: BUTTON -->
      </div>
    </form>
    <!-- END:: UPDATE FORM WRAPPER -->
  </div>
</template>

<script>
export default {
  name: "Update",
  data() {
    return {
      // START:: BUTTON LOADER HANDLING DATA
      btnIsLoading: false,
      // END:: BUTTON LOADER HANDLING DATA

      // START:: CREATE DATA
      updateData: {
        project_name: null,
        description_location: null,
        website_link: null,
        phone: null,
        email: null,
        whatsapp: null,
        facebook: null,
        twitter: null,
        youtube: null,
        instagram: null,
        pinterest: null,
        ios_link: null,
        android_link: null,
        address: null,
        lat: null,
        lng: null,
      },
      // END:: CREATE DATA

      // START:: MAP
      center: {
        lat: null,
        lng: null,
      },

      markers: [],
      coordinates_to_edit: { lat: 0, lng: 0 },
      // END:: MAP
    };
  },
  methods: {
    // START:: UPDATE LOCATION
    updateCoordinates(location) {
      this.updateData = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    clickMethod(m) {
      this.center = m.position;
    },
    // END:: UPDATE LOCATION

    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;
          this.updateData.lat = this.center.lat;
          this.updateData.lng = this.center.lng;
        });
      }
    },

    // START:: G-MAP GET ADDRESS
    getAddressAr() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          console.log(place);
          bounds.extend(place.geometry.location);
          place.geometry.location.lat();
          place.geometry.location.lng();
          place.formatted_address;
          self.updateData.address = place.formatted_address;
          self.center.lat = place.geometry.location.lat();
          self.center.lng = place.geometry.location.lng();
          self.updateData.lat = place.geometry.location.lat();
          self.updateData.lng = place.geometry.location.lng();
          self.markers[0].position.lat = place.geometry.location.lat();
          self.markers[0].position.lng = place.geometry.location.lat();
        });
      });
    },
    // START:: G-MAP GET ADDRESS

    // START:: CHECK IF INPUT IS EMPTY (SPECIFIC TO ANIMATED PLACEHOLDER INPUTS)
    checkIfInputIsEmpty(e) {
      let inputElement = e.currentTarget;
      if (inputElement.value.length > 0) {
        inputElement.classList.add("not_empty");
      } else {
        inputElement.classList.remove("not_empty");
      }
    },
    // END:: CHECK IF INPUT IS EMPTY (SPECIFIC TO ANIMATED PLACEHOLDER INPUTS)

    //START:: GET DATA
    getData() {
      this.axios({
        method: "GET",
        url: "settings",
      }).then((res) => {
        this.updateData.project_name = res.data.data.project_name;
        this.updateData.description_location =
          res.data.data.description_location;
        this.updateData.website_link = res.data.data.website_link;
        this.updateData.phone = res.data.data.phone;
        this.updateData.email = res.data.data.email;
        this.updateData.whatsapp = res.data.data.whatsapp;
        this.updateData.facebook = res.data.data.facebook;
        this.updateData.twitter = res.data.data.twitter;
        this.updateData.youtube = res.data.data.youtube;
        this.updateData.instagram = res.data.data.instagram;
        this.updateData.pinterest = res.data.data.pinterest;
        this.updateData.ios_link = res.data.data.ios_link;
        this.updateData.android_link = res.data.data.android_link;
        this.updateData.address = res.data.data.address;
        this.updateData.lat = +res.data.data.lat;
        this.updateData.lng = +res.data.data.lng;
      });
    },
    //END:: GET DATA

    // START:: VALIDATE CREATE FORM
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.updateData.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("settings.contactData.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        console.log(this.updateData);
        const data = new FormData();
        data.append("project_name", this.updateData.project_name);
        data.append(
          "description_location",
          this.updateData.description_location
        );
        data.append("website_link", this.updateData.website_link);
        data.append("phone", this.updateData.phone);
        data.append("email", this.updateData.email);
        data.append("whatsapp", this.updateData.whatsapp);
        data.append("facebook", this.updateData.facebook);
        data.append("twitter", this.updateData.twitter);
        data.append("youtube", this.updateData.youtube);
        data.append("instagram", this.updateData.instagram);
        data.append("pinterest", this.updateData.pinterest);
        data.append("ios_link", this.updateData.ios_link);
        data.append("android_link", this.updateData.android_link);
        data.append("address", this.updateData.address);
        data.append("lat", this.updateData.lat);
        data.append("lng", this.updateData.lng);

        this.axios({
          method: "post",
          url: "settings",
          data: data,
        })
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("editSuccess"),
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            this.$router.push({ path: "/" });
          })
          .catch((err) => {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
          });
      }
    },
    // END:: VALIDATE CREATE FORM
  },

  created() {
    this.getLocation();
    this.getData();
  },
};
</script>
